/**
 * Player Image Types
 *
 * Types for player-uploaded images (profile portraits, token images).
 * Images stored in Supabase Storage, metadata tracked in machina_player_images.
 */
import { z } from 'zod';
export const ImagePurposeSchema = z.enum(['profile', 'token', 'general']);
export const PlayerImageSchema = z.object({
    id: z.string().uuid(),
    userId: z.string().uuid(),
    storagePath: z.string(),
    publicUrl: z.string(),
    originalName: z.string(),
    purpose: ImagePurposeSchema,
    width: z.number().optional(),
    height: z.number().optional(),
    sizeBytes: z.number().optional(),
    mimeType: z.string().optional(),
    createdAt: z.string(),
});
//# sourceMappingURL=player-image-types.js.map